import styled from 'styled-components';

import {colors, inputFieldBase, textEllipsis, transition} from 'theme';

export const TextareaContainer = styled.span`
    position: relative;
    display: block;
    width: 100%;
`;

export const TextareaElem = styled.textarea<{
    hasError?: boolean;
    disabled?: boolean;
}>`
    ${textEllipsis};
    ${(p) => inputFieldBase(p.disabled ? 'disabled' : p.hasError ? 'error' : 'normal')};

    display: block;
    width: 100%;
    box-sizing: border-box;
    height: 80px;
    cursor: ${(p) => (p.disabled ? 'not-allowed' : 'text')};
    transition: border-color ${transition.duration};
    resize: none;
    white-space: normal;
    overflow-y: auto;

    &::-webkit-input-placeholder {
        color: ${colors.border};
    }

    &::-moz-placeholder {
        color: ${colors.border};
    }

    &:-ms-input-placeholder {
        color: ${colors.border};
    }

    &::-ms-input-placeholder {
        color: ${colors.border};
    }

    &::-ms-clear {
        display: none;
    }
`;
